export const NUVEMPAGO_TRANSPARENT_CHECKOUT_IN_ADVANCED_SETTINGS_FEATURE_FLAG =
  'fs-nuvempago-set-transparent-checkout-in-advanced-settings';

export const NUVEMPAGO_ACTIVE_STATUS_TAG_FOR_NEW_COHORTS_FEATURE_FLAG =
  'fs-nuvempago-active-status-tag-for-new-cohorts';
